
import { defineComponent } from 'vue'
import glossaryDefinitionDescriptor from '@/modules/managers/glossaryDefinition/GlossaryDefinitionDescriptor.json'

export default defineComponent({
    name: 'document-execution-word-detail',
    components: {},
    props: { wordDetail: { type: Object }, selectedWordName: { type: String } },
    data() {
        return {
            glossaryDefinitionDescriptor,
            contentInfo: null as any
        }
    },
    watch: {
        wordDetail() {
            this.loadWordInfo()
        }
    },
    created() {
        this.loadWordInfo()
    },
    methods: {
        loadWordInfo() {
            this.contentInfo = this.wordDetail
        }
    }
})
